export type RegisterReturnAddressCheckForm = {
    orderNumber: string;
    postCode: string;
    houseNumber: string;
};

export type RevokeOrderAddressCheckForm = RegisterReturnAddressCheckForm;

export enum returnSteps {
    addressCheck,
    selectProduct,
    selectReason,
    downloadReturnForm,
    errorPage
}

export enum revokeSteps {
    addressCheck,
    selectProduct,
    downloadReturnForm,
    errorPage
}

export type DisplayProduct = {
    id:string;
    thumbnail:string;
    imgSource:string;
    partNumber:string;
    name:string;
    title:string;
    quantity:number;
    orderPlacedDate:string;
    href:string;
}

export type SelectedReturnItem = {
    id: string;
    quantity: number;
}